"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pratovecchio-stia": {
    "6377e360": [{
      "hkey": "bba51643",
      "slug": "pratovecchio-stia",
      "name": "Pratovecchio Stia",
      "primary": true,
      "skipSearch": false
    }],
    "castel-castagnaio": [{
      "hkey": "bba51643",
      "slug": "pratovecchio-stia",
      "name": "Pratovecchio Stia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fe458d42": [{
      "hkey": "bba51643",
      "slug": "pratovecchio-stia",
      "name": "Pratovecchio Stia",
      "primary": true,
      "skipSearch": false
    }],
    "san-donato": [{
      "hkey": "bba51643",
      "slug": "pratovecchio-stia",
      "name": "Pratovecchio Stia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a422dd55": [{
      "hkey": "bba51643",
      "slug": "pratovecchio-stia",
      "name": "Pratovecchio Stia",
      "primary": true,
      "skipSearch": false
    }],
    "valiana": [{
      "hkey": "bba51643",
      "slug": "pratovecchio-stia",
      "name": "Pratovecchio Stia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;